import { useEffect, useRef, useSyncExternalStore } from 'react';
import { playSfx, startMusic, stopMusic, claimMusic, isMuted, subscribeMuted } from './sfx';
import type { RushMidSnapshot } from './useRushMidMatch';

export function useRushMidMuted(): boolean {
  return useSyncExternalStore(subscribeMuted, isMuted, () => false);
}

export function useRushMidAudio(
  assetsReady: boolean,
  status: RushMidSnapshot['status'],
  partyMembers: number | null,
): void {
  const muted = useRushMidMuted();
  const prevStatusRef = useRef(status);
  useEffect(() => {
    if (!assetsReady) return;
    if (status === 'BUYING' && prevStatusRef.current !== 'BUYING') playSfx('match_found');
    if (status === 'PLAYING' && prevStatusRef.current !== 'PLAYING') playSfx('battle_start', 0.8);
    prevStatusRef.current = status;
  }, [assetsReady, status]);

  const prevMembersRef = useRef<number | null>(null);
  useEffect(() => {
    const prev = prevMembersRef.current;
    prevMembersRef.current = partyMembers;
    if (assetsReady && prev != null && partyMembers != null && partyMembers > prev) playSfx('party_join', 0.6);
  }, [assetsReady, partyMembers]);

  useEffect(() => {
    const inLobby = status === 'NONE' || status === 'PARTY' || status === 'OPEN';
    if (!muted && (!assetsReady || inLobby)) void startMusic();
    else stopMusic();
  }, [assetsReady, status, muted]);

  useEffect(() => claimMusic(), []);
}
